const CAROUSEL_THUMBS_SELECTOR = '.js-carousel-thumbs';
export default (context: HTMLElement | DocumentFragment = document) => {
    (
        context.querySelectorAll(
            CAROUSEL_THUMBS_SELECTOR
        ) as NodeListOf<HTMLElement>
    ).forEach((carouselThumb) => {
        var thumbPartner = carouselThumb.parentElement.querySelector(
            '[data-thumbs-partner]'
        ) as HTMLElement;
        var thumbs = carouselThumb.querySelectorAll('.product-images__entity');

        thumbs.forEach((thumb) => {
            thumb.addEventListener('click', () => {
                var slideNumber = parseInt(thumb.getAttribute('data-slide'));
                thumbPartner['swiper'].slideToLoop(slideNumber);
            });
        });
    });
};
